<template>
  <footer
    id="footer"
    class="app-footer inverted padding-y-2xl"
    style="--link-color: var(--white); --link-hover-color: var(--fa-blue)"
  >
    <div class="container">
      <div class="row roomy align-top">
        <div class="column-12 laptop:column-4 margin-bottom-md laptop:margin-bottom-0">
          <h5>Go Make Something Awesome</h5>
        </div>
        <div class="column-12 laptop:column-8">
          <div
            class="display-flex flex-column laptop:flex-row laptop:flex-content-end tablet:size-sm"
            style="width: 100%"
          >
            <div
              class="display-flex flex-column tablet:flex-row margin-bottom-md laptop:margin-bottom-0 laptop:margin-right-2xl"
              style="gap: var(--spacing-sm)"
            >
              <site-link
                :to="{ name: 'license.pro' }"
                class="no-underline padding-right-3xs"
                @click.native="$posthog.capture('main_footer_link_click', { destination: 'license' })"
              >
                License
              </site-link>
              <site-link
                :to="{ name: 'tos' }"
                class="no-underline padding-left-0 padding-right-3xs tablet:padding-left-3xs"
                @click.native="$posthog.capture('main_footer_link_click', { destination: 'terms_of_service' })"
              >
                Terms of Service
              </site-link>
              <site-link
                :to="{ name: 'privacy' }"
                class="no-underline padding-left-0 padding-right-3xs tablet:padding-left-3xs"
                @click.native="$posthog.capture('main_footer_link_click', { destination: 'privacy_policy' })"
              >
                Privacy Policy
              </site-link>
              <site-link
                :to="{ name: 'refunds' }"
                class="no-underline padding-left-0 padding-right-3xs tablet:padding-left-3xs"
                @click.native="$posthog.capture('main_footer_link_click', { destination: 'refunds' })"
              >
                Refunds
              </site-link>
              <button
                class="no-underline link flat text-left margin-0 padding-0 padding-left-0 padding-right-3xs tablet:padding-left-3xs"
                style="--button-border-radius: 0"
                @click.prevent="manageCookiePreferences"
              >
                Cookie Preferences
              </button>
            </div>

            <p style="color: var(--fa-gravy)">&copy; Fonticons, Inc.</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'PageFooterSimple',

    methods: {
      ...mapActions('cookiePreferences', ['manageCookiePreferences'])
    }
  }
</script>
